import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorageService } from 'src/app/local-storage.service';
import { DialogActions } from 'src/app/utils/DialogActionsArchive';
import { ServiceProviderSubjectService } from 'src/services/service-provider-subject.service';
import { ToastrImplService } from 'src/services/toastr.service';
import { UserService } from 'src/services/user.service';
import { ArchiveSubjectComponent } from '../subject-details/archive-subject/archive-subject.component';
import { ModalSizeEnum } from 'src/types';
import { DataSharingService } from 'src/services/data-sharing.service';
import { ServiceProviderAssessmentDialogComponent } from './service-provider-assessment-dialog/service-provider-assessment-dialog.component';
import { ServiceProviderIntakeAssessmentDialogComponent } from './service-provider-intake-assessment-dialog/service-provider-intake-assessment-dialog.component';
import { ServiceProviderIndividualServicePlanDialogComponent } from './service-provider-individual-service-plan-dialog/service-provider-individual-service-plan-dialog.component';
import { ServiceProviderFunctionalEfficiencyAssessmentScaleDialogComponent } from './service-provider-functional-efficiency-assessment-scale-dialog/service-provider-functional-efficiency-assessment-scale-dialog.component';

@Component({
  selector: 'app-service-provider-subject-details',
  templateUrl: './service-provider-subject-details.component.html',
  styleUrls: ['./service-provider-subject-details.component.scss']
})
export class ServiceProviderSubjectDetailsComponent implements OnInit {
  showDivider = false;
  isAdmin = false;
  loggedIn: any;
  isSubjectHistoryRendered = false;
  isAssociate = false;

  subject: any;
  familyDossier: any;
  familyType: any;
  registrationId = null;
  object: any = {
    subject: '',
    action: '',
    isServiceProviderUser: true,
  };
  isArchived: boolean;
  isArchivedInCsr: boolean;
  roleLength: any;

  constructor(
    private route: ActivatedRoute,
    private translate: TranslateService,
    private localStorageService: LocalStorageService,
    private userService: UserService,
    private serviceProviderSubjectService: ServiceProviderSubjectService,
    private toastr: ToastrImplService,
    public dialog: MatDialog,
    private dataSharingService: DataSharingService,
  ) {
    this.loggedIn = JSON.parse(this.localStorageService.get('loggedUser'));
    this.isAdmin = this.userService.isGlobalAdmin();
    this.roleLength = JSON.parse(this.localStorageService.get('loggedUser')).role.length;
    this.isAssociate = this.roleLength === 1 ? this.userService.isAssociate() : this.localStorageService.get('primaryRole') === ' Сарадник';

    this.route.params.subscribe(params => {
      const serviceProviderSubjectId = params.id;
      this.getCurrentServiceProviderSubject(serviceProviderSubjectId);
    });
  }

  ngOnInit(): void {}

  selectTab(tab: any) {
    if (tab.index === 2) {
      this.isSubjectHistoryRendered = true;
    }
  }

  getCurrentServiceProviderSubject(serviceProviderSubjectId: any) {
    this.serviceProviderSubjectService.getCurrentServiceProviderSubject(serviceProviderSubjectId).subscribe(res => {
      this.subject = res;
      if (this.subject.dateOfBirth !== null) {
        this.subject.dateOfBirth = this.subject.dateOfBirth.replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$1.$2.$3.');
      }
      this.subject.dateOfModification = this.subject.dateOfModification.replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$1.$2.$3.');
      this.subject.dateOfCreation = this.subject.dateOfCreation.replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$1.$2.$3.');
      this.registrationId = res.registrationId;

      if (this.subject?.disabledPerson || this.subject?.disabilityType || this.subject?.occupation || this.subject?.employment || this.subject?.education || this.subject?.maritalStatus) {
        this.showDivider = true;
      }

      if (res.familyDossier === 'NONE') {
        res.familyDossier = null;
      } else {
        this.translate.get('SUBJECTS.FAMILY_DOSSIER.' + res.familyDossier).subscribe((result: string) => {
          this.familyDossier = result;
        });
      }

      if (res.familyType === 'NONE') {
        res.familyType = null;
      } else {
        this.translate.get('SUBJECTS.FAMILY_TYPE.' + res.familyType).subscribe((result: string) => {
          this.familyType = result;
        });
      }

      this.isArchived = res.serviceProviderStatus === 'PASSIVE';
      this.isArchivedInCsr = res.csrStatus === 'ПАСИВАН';
    });
  }

  reloadSubject(subjectId: number) {
    this.getCurrentServiceProviderSubject(subjectId);
  }

  openDialog(action: 'archive' | 'unarchive', obj: any) {
    this.object.subject = obj;
    this.object.action = action;

    if (action === DialogActions.ARCHIVE) {
      this.openArchiveComponent();
    } else if (action === DialogActions.UNARCHIVE) {
      this.openArchiveComponent();
    }
  }

  openArchiveComponent() {
    const dialogRef = this.dialog.open(ArchiveSubjectComponent, {
      panelClass: 'overlay-panel',
      disableClose: true,
      width: ModalSizeEnum.MINI,
      data: this.object,
    });

    dialogRef.afterClosed().subscribe(result => {
      const { event, data } = result;
      if (event === DialogActions.ARCHIVE || event === DialogActions.UNARCHIVE) {
        this.subject.dateOfModification = new Date();
        this.isSubjectHistoryRendered = false;
        this.subject.serviceProviderStatus = event === DialogActions.ARCHIVE ? 'PASSIVE' : 'ACTIVE';
        if (event === DialogActions.ARCHIVE) {
          this.isArchived = true;
          this.toastr.success('SNACKBAR.SUBJECT_ARCHIVED');
          this.dataSharingService.subjectStatusChange.next(true);
        } else {
          this.isArchived = false;
          this.toastr.success('SNACKBAR.SUBJECT_RETURNED_FROM_ARCHIVE');
          this.dataSharingService.subjectStatusChange.next(false);
        }
      } if (data.status === 400) {
        this.toastr.error('SERVICE_PROVIDERS.SUBJECT_RECORD.HAS_ACTIVE_RECORDS_ERROR');
      } else if (event !== 'Cancel') {
        this.toastr.error('SNACKBAR.SUBJECT_NOT_ARCHIVED');
      }
    });
  }

  openAssessmentDialog() {
    const dialogRef = this.dialog.open(ServiceProviderAssessmentDialogComponent, {
      panelClass: 'overlay-panel',
      disableClose: true,
      width: ModalSizeEnum.EXTRA_LARGE,
      data: {
        subject: this.subject
      }
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }

  openIntakeAssessmentDialog() {
    const dialogRef = this.dialog.open(ServiceProviderIntakeAssessmentDialogComponent, {
      panelClass: 'overlay-panel',
      disableClose: true,
      width: ModalSizeEnum.EXTRA_LARGE,
      data: {
        subject: this.subject
      }
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }

  openIndividualServicePlanDialog() {
    const dialogRef = this.dialog.open(ServiceProviderIndividualServicePlanDialogComponent, {
      panelClass: 'overlay-panel',
      disableClose: true,
      width: ModalSizeEnum.EXTRA_LARGE,
      data: {
        subject: this.subject
      }
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }

  openFunctionalEfficiencyAssessmentScaleDialog() {
    const dialogRef = this.dialog.open(ServiceProviderFunctionalEfficiencyAssessmentScaleDialogComponent, {
      panelClass: 'overlay-panel',
      disableClose: true,
      width: ModalSizeEnum.EXTRA_LARGE,
      data: { 
        subject: this.subject
      }
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }

}
